//@ts-check
/** @param {Fox} fox */
module.exports = (fox) => {
	//@ts-ignore
	const RuleBase = require('../rule')(fox);
	//@ts-ignore
	const showGDPRForMember = require('./common/show-gdpr-popup');

	const { SESSION_VAR_NAME_COOKIE } = require('GDPR-popups/constants.es');

	return fox.extend({
		/** @param {Controller} pm */
		__constructor(pm, fakeParams, ...args) {
			const params = {};

			Object.defineProperty(params, 'enabled', {
				get: () => !fox.isEmpty(pm.member) && pm.hasAccess('guest'),
				enumerable: true
			});

			pm.handleEvent(
				pm,
				'permissions_update',
				/** @param {Array} keys */
				(keys) => {
					if (keys.indexOf('guest') !== -1) {
						this.execute();
					}
				},
				{
					prefix: 'free_rule_handler',
					sync: true
				}
			);

			this.super('__constructor', [pm, params, ...args]);
		},

		granted() {
			try {
				sessionStorage.removeItem(SESSION_VAR_NAME_COOKIE);
			} catch (e) {} finally {
				showGDPRForMember(fox);
			}
		}
	}, RuleBase, null, 'Rule_Free')
}


// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/components/user-access/widget/rules/free.es.js